// extracted by mini-css-extract-plugin
export default {"background":"Login_background__zC9P2","login-form":"Login_login-form__MHtjB","photo":"Login_photo__J3MFO","signup":"Login_signup__xMxWj"};